<template>
  <div class="login-form">
    <section class="hero">
      <div class="hero-body">
        <div class="container is-fluid login-box">
          <section>
            <b-field label="Email" position="is-centered">
              <b-input type="email"
                name="email"
                v-focus
                v-model="email"
                @keyup.native.enter="loginUser"
              />
            </b-field>
            <b-field label="Password" position="is-centered" @keyup.enter="loginUser">
              <b-input type="password"
                name="password"
                password-reveal
                v-model="password"
                @keyup.native.enter="loginUser"/>
            </b-field>
            <div class="level">
              <div class="level-left">
                <router-link to="reset-password">
                  Forgot your password?
                </router-link>
              </div>
              <div class="level-right">
                <button type="submit" class="button is-primary"
                  @click="loginUser">Login</button>
              </div>
            </div>
          </section>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

export default {
  name: 'LoginForm',
  data () {
    return {
      email: null,
      password: null
    }
  },
  mounted () {
    if (this.$auth.check()) {
      this.$router.replace({name: 'main'})
    }
  },
  methods: {
    loginUser (e) {
      if (this.email && this.password) {
        const credentials = {
          username: this.email,
          password: this.password
        }

        const redirect = this.$auth.redirect()

        this.$auth.login({
          data: credentials,
          rememberMe: true,
          redirect: { name: redirect ? redirect.from.name : 'main' }
        })
          .then(response => {
            this.$toast.open({
              duration: 500,
              message: 'Logged in',
              type: 'is-info'
            })
          })
          .catch(error => {
            console.log('error ' + error)
            this.$toast.open({
              duration: 5000,
              message: 'Something went wrong. Please check your email and password or try later.',
              type: 'is-danger'
            })
          })
      }
    }
  }
}
</script>

<style scoped>
.login-box {
  margin: auto;
  max-width: 400px;
}
</style>
